// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"409":"76912601","845":"09f8f68c","865":"347fcc8e"}[chunkId] + ".chunk.js";
};